export default __webpack_public_path__ + "static/media/HHSTSSPrintOutsLarge.30ee2834.pdf";